import { Modal, ModalContent } from 'pobble-components/dist/modal'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { faPenFancy } from '@fortawesome/pro-solid-svg-icons/faPenFancy'
import { faClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck'
import { faTh } from '@fortawesome/pro-solid-svg-icons/faTh'
import { faText } from '@fortawesome/pro-solid-svg-icons/faText'
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare'
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink'
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage'
import ButtonElement from 'pobble-components/dist/button-element'
import injectSheet from 'react-jss'
import pattern from './pattern.png'
import { useDispatch, useSelector } from 'react-redux'
import { openCreateSlideDialog } from '../../redux/builder.actions'
import { getPresentation } from '../../../../../../stores/presentation/presentation.selectors'
import { createSlide } from '../../../../../../stores/presentation/presentation.actions'

const buttons = [
  {
    title: 'Work exemplar',
    icon: <FontAwesomeIcon icon={faFileAlt} />,
    action: dispatch => dispatch(openCreateSlideDialog('WorkExemplar'))
  },
  {
    title: 'Success Criteria',
    icon: <FontAwesomeIcon icon={faClipboardCheck} />,
    action: dispatch => dispatch(openCreateSlideDialog('SuccessCriteria'))
  },
  {
    title: 'Word Bank',
    icon: <FontAwesomeIcon icon={faTh} />,
    action: dispatch => dispatch(openCreateSlideDialog('WordBank'))
  },
  {
    title: 'Image',
    icon: <FontAwesomeIcon icon={faImage} />,
    action: dispatch => dispatch(openCreateSlideDialog('Image'))
  },
  {
    title: 'Exercise',
    icon: <FontAwesomeIcon icon={faPenFancy} />,
    action: dispatch => dispatch(openCreateSlideDialog('Exercise'))
  },
  {
    title: 'Youtube Video',
    icon: <FontAwesomeIcon icon={faPlay} />,
    action: dispatch => dispatch(openCreateSlideDialog('Video'))
  },
  {
    title: 'Text',
    icon: <FontAwesomeIcon icon={faText} />,
    action: dispatch => dispatch(openCreateSlideDialog('Text'))
  },
  {
    title: 'Lined or Blank',
    icon: <FontAwesomeIcon icon={faSquare} />,
    action: dispatch =>
      dispatch(
        createSlide({
          type: 'Blank',
          line_type: 'guides',
          line_height: 'medium',
          color: 'none'
        })
      )
  },
  {
    title: 'Website Link',
    icon: <FontAwesomeIcon icon={faLink} />,
    action: dispatch => dispatch(openCreateSlideDialog('Link'))
  }
]

const CreateSlide = injectSheet({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px',
    listStyle: 'none',
    margin: '0',
    padding: '0'
  },
  button: {
    height: '120px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff',
    color: 'var(--gray-)',
    font: 'var(--body--)',
    fontWeight: 'bold',
    borderRadius: '8px',
    gap: '8px',
    transition: 'box-shadow 0.1s ease-out',
    '&:hover, &:focus': {
      color: 'var(--dark-blue)',
      boxShadow: '0 0 0 4px var(--blue), 0 0 0 6px #fff',
      '& svg': {
        color: 'var(--dark-blue)'
      }
    }
  },
  icon: {
    width: '48px',
    height: '48px',
    borderRadius: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'var(--light-gray--)',
    '& svg': {
      fontSize: '24px',
      color: 'var(--gray--)'
    }
  }
})(function CreateSlide({ classes, requestClose }) {
  const dispatch = useDispatch()

  const presentation = useSelector(getPresentation)

  return (
    <ul className={classes.container}>
      {buttons.map(button => {
        return (
          <ButtonElement
            onClick={() => {
              requestClose()
              button.action(dispatch, presentation)
            }}
            className={classes.button}>
            <span className={classes.icon}>{button.icon}</span>
            <span>{button.title}</span>
          </ButtonElement>
        )
      })}
    </ul>
  )
})

export const CreateSlideModal = injectSheet({
  content: {
    backgroundSize: 'auto 140px',
    background: `linear-gradient(180deg, rgba(0, 175, 236, .92), rgba(0, 175, 236, .92)), url("${pattern}");`,
    borderRadius: '8px',
    padding: '48px',
    maxWidth: '700px'
  },
  header: {
    textAlign: 'center',
    background: 'var(--light-gray)',
    font: 'var(--heading--)'
  },
  title: {
    font: 'var(--heading)',
    textAlign: 'center',
    margin: '-16px 0 24px',
    color: '#fff'
  }
})(({ isOpen, requestClose, classes }) => {
  return (
    <>
      <Modal closeButton isOpen={isOpen} requestClose={requestClose}>
        <ModalContent className={classes.content}>
          <h2 className={classes.title}>Select a slide type</h2>
          <CreateSlide requestClose={requestClose} />
        </ModalContent>
      </Modal>
    </>
  )
})
